import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'text-icon-main-inversion container mx-auto flex max-w-[846px] flex-col gap-8 px-3 md:flex-row',
    suggestions: 'flex w-full flex-1 flex-col gap-5 md:gap-6',
    products: '',
    productList:
      'flex max-w-[368px] flex-wrap gap-x-4 gap-y-6 py-2 max-md:snap-x max-md:snap-mandatory max-md:flex-nowrap max-md:overflow-x-auto max-md:pt-9.5 max-md:[scrollbar-width:none] max-md:[&::-webkit-scrollbar]:hidden',
    productItem: 'max-w-[96px] max-md:shrink-0 md:max-w-[112px]',
    categories: 'flex flex-col gap-4.5 md:gap-6',
    content: 'flex justify-between align-top max-md:flex-col'
  },
  variants: {
    color: {
      primary: ''
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
